<template>
  <div>
    <el-drawer
      v-if="visible"
      :title="title"
      :visible="visible"
      direction="rtl"
      :size="800"
      show-close
      @close="close"
      :before-close="handleClose"
      append-to-body
    >
      <div>
        <GoodsInfo
          ref="goodsInfoRef"
          :changeCodeList="[pendingGoodsPackageWorklogCode]"
          :type="'package'"
          :disabled="disabled"
          @changeGoods="changeGoods()"
        />
        <BatchUserTable
          ref="userTable"
          class="mt-2"
          :disabled="disabled"
          :fillMethoDis="fillMethoDis"
          :userList="formData.userList"
          :workLogTime.sync="formData.workLogTime"
          @chooseUserConfirm="chooseUserConfirm"
          @del="del"
        />
        <div
          class="mt-2 p-3"
          style="background-color: #F8F8F9;border-radius: 10px;"
          v-if="formData.pendingGoodsCode"
        >
          <el-form
            ref="form"
            :model="formData"
            :rules="rules"
            :disabled="disabled"
            size="mini"
            @submit.native.prevent
            label-position="top"
          >
            <el-row :gutter="10">
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_workShiftCode') || '班次'"
                  prop="workShiftCode"
                >
                  <el-radio-group
                    v-model="formData.workShiftCode"
                    size="small"
                    @change="workShiftChange"
                  >
                    <el-radio
                      v-for="(item, key) in mrpWorkShiftData"
                      :key="key"
                      :label="item.value"
                      >{{ item.label }}</el-radio
                    >
                  </el-radio-group>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item
                  :label="
                    $l('form_label_pdProcessDictStepExtensions') || '报工工序'
                  "
                  prop="pdProcessDictStepExtensions"
                >
                  <el-select
                    v-model="formData.pdProcessDictStepExtensions"
                    :placeholder="''"
                    size="mini"
                    filterable
                    clearable
                    style="width: 100%"
                    @change="techChange"
                  >
                    <el-option
                      v-for="item in pdProcessDictStepOptions"
                      :key="item.value"
                      :label="item.v_label"
                      :value="item.value"
                    >
                      <span style="float: left">{{ item.label }}</span>
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="16">
                <el-form-item
                  :label="$l('form_label_pdTechDictCode') || '工序工艺'"
                  prop="pdTechDictCode"
                >
                  <el-input
                    v-model="formData.techName"
                    :maxlength="500"
                    clearable
                    style="width:100%"
                    readonly
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :span="6">
                <el-form-item
                  :label="$l('form_label_reportedWorkQty') || '报工数量'"
                  prop="reportedWorkQty"
                >
                  <el-input-number
                    v-model="formData.reportedWorkQty"
                    :controls="false"
                    style="width:100%"
                    :precision="0"
                    :max="100000000"
                    :min="0"
                    :step="1"
                    @change="splitWorklogUser()"
                  >
                  </el-input-number>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  :label="$l('form_label_techChargeUnitText') || '数量单位'"
                  prop="techChargeUnit"
                >
                  <el-input
                    v-model="formData.techChargeUnitText"
                    :maxlength="500"
                    clearable
                    style="width:100%"
                    readonly
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$l('form_label_totalActualTimeSeconds') || '实际耗时'"
                  prop="totalActualTimeSeconds"
                >
                  <template>
                    <div style="display: flex;">
                      <div>
                        <el-input-number
                          v-model="formData.consumerHour"
                          :controls="false"
                          :precision="0"
                          :max="100000000"
                          :min="0"
                          :step="1"
                          v-el-inputnumber-default0
                          @change="updateTimeSeconds()"
                        >
                        </el-input-number>
                      </div>

                      <div class="mx-2">
                        {{ $l('form_label_consumerHour') || '小时' }}
                      </div>
                      <div>
                        <el-input-number
                          v-model="formData.consumerMinute"
                          :controls="false"
                          :precision="0"
                          :max="100000000"
                          :min="0"
                          :step="1"
                          v-el-inputnumber-default0
                          @change="updateTimeSeconds()"
                        >
                        </el-input-number>
                      </div>

                      <div class="mx-2">
                        {{ $l('form_label_consumerMinute') || '分钟' }}
                      </div>
                    </div>
                  </template>
                </el-form-item>
              </el-col>
              <el-col :span="24" class="my-2">
                <div
                  style="font-weight: 700;color: #101010;"
                  class=" text-left"
                >
                  {{ $l('form_label_error_text') || '异常情况' }}
                </div>
              </el-col>
              <el-col :span="24">
                <el-form-item
                  :label="$l('form_label_breakReason') || '中断原因'"
                  prop="breakReasonCodeList"
                >
                  <DictCheckBox
                    :checkList="formData.breakReasonCodeList"
                    url="/master/common/dict/biz"
                    :body="{
                      dictType: 'mrpWorkBreakReason',
                      sortColumn: 'value',
                    }"
                    @change="reasonChange"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  :label="$l('form_label_breakDuration') || '中断时长'"
                >
                  <template>
                    <div style="display: flex;">
                      <div>
                        <el-input-number
                          v-model="formData.breakDuration"
                          :controls="false"
                          :precision="0"
                          :max="100000000"
                          :min="0"
                          :step="1"
                          v-el-inputnumber-default0
                        >
                        </el-input-number>
                      </div>

                      <div class="mx-2">
                        {{ $l('form_label_consumerMinute') || '分钟' }}
                      </div>
                    </div>
                  </template>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div
          class="mt-2 p-3"
          style="display: flex;justify-content: space-between; align-items: center;"
        >
          <div>
            <span class="mr-2" style="font-size: 16px; color: #99A1B7">{{
              $l('form_label_createTime') || '填写时间:'
            }}</span>
            <span style="font-size: 16px; color: #071437">
              {{
                `${formData.createByName || '--'} at ${formData.createTime ||
                  '--'}`
              }}</span
            >
          </div>
          <div>
            <span class="mr-2" style="font-size: 16px; color: #99A1B7">{{
              $l('form_label_modifyTime') || '更新时间:'
            }}</span>
            <span style="font-size: 16px; color: #071437">
              {{
                `${formData.modifyByName || '--'} at ${formData.modifyTime ||
                  '--'}`
              }}</span
            >
          </div>
        </div>
        <div class="d-flex justify-content-end mb-2 mt-3">
          <el-button
            type="primary"
            size="small"
            v-if="!disabled"
            @click="save()"
            >{{ $l('INDEX.btn_save') || '保存' }}</el-button
          >
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import GoodsInfo from '@/views/factory/production/prodLineQualityRecord/components/edit-form/goods-info'
import BatchUserTable from './batch-user'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import DictCheckBox from '@/views/factory/components/dict-check-box'
import { request } from '@/api/service'
import { add, divideRound, subtract } from '@/libs/util.number.js'
export default {
  components: {
    BatchUserTable,
    DictCheckBox,
    GoodsInfo,
  },
  props: {
    visible: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    pendingGoodsPackageWorklogCode: { type: String, default: '' },
    pendingGoodsCode: { type: String, default: '' },
    title: { type: String, default: '' },
  },
  mixins: [EditLoading],
  data() {
    return {
      mrpWorkShiftData: [],
      pdProcessDictStepOptions: [],
      fillMethoDis: false,
      formData: { specName: '', breakReasonCodeList: ['R'] },
      rules: {
        workShiftCode: [
          {
            required: true,
            message: this.$l('form_label_rules_workShiftCode') || '请选择班次',
            trigger: 'change',
          },
        ],
        pdProcessDictStepExtensions: [
          {
            required: true,
            message:
              this.$l('form_label_rules_pdProcessDictStepExtensions') ||
              '请选择报工工序',
            trigger: 'change',
          },
        ],
        pdTechDictCode: [
          {
            required: true,
            message:
              this.$l('form_label_rules_pdTechDictCode') || '请选择工序工艺',
            trigger: 'change',
          },
        ],
        reportedWorkQty: [
          {
            required: true,
            message:
              this.$l('form_label_rules_reportedWorkQty') || '请输入报工数量',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  new Error(
                    this.$l('form_label_rules_reportedWorkQty_1') ||
                      '报工数量不能小于1'
                  )
                )
                return
              }
              callback()
            },
          },
        ],
        totalActualTimeSeconds: [
          {
            required: true,
            message:
              this.$l('form_label_rules_totalActualTimeSeconds') ||
              '请输入实际耗时',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(
                  new Error(
                    this.$l('form_label_rules_totalActualTimeSeconds_1') ||
                      '实际耗时不能小于1分钟'
                  )
                )
                return
              }
              callback()
            },
          },
        ],
      },
    }
  },
  async mounted() {
    await this.getProcessData()
    await this.getData()
    await this.getOptionData()
  },
  watch: {
    "formData.workLogTime": {
      handler(newVal) {
        // 同步 formData.reportDate 和 formData.workLogTime
        this.formData.reportDate = newVal || "";
      },
      immediate: true,
    },
  },
  methods: {
    async getData() {
      if (this.pendingGoodsPackageWorklogCode) {
        this.$api
          .pendingGoodsPackageWorkLogDetailApi(
            this.pendingGoodsPackageWorklogCode
          )
          .then((res) => {
            const breakReasonCodeList = res.body.breakReasonCode
              ? res.body.breakReasonCode.split(',')
              : []
            this.formData = { ...res.body, breakReasonCodeList }
            this.calConsumerTime()
            this.fillMethoDis = this.formData.fillMethod != 'S'
            this.$refs.goodsInfoRef.getData(this.formData.pendingGoodsCode)
          })
      }
    },
    async getOptionData() {
      request({
        url: '/master/common/dict/biz',
        method: 'POST',
        data: { dictType: 'mrpWorkShift' },
      }).then((res) => {
        const dataList = res.body.data || []
        this.mrpWorkShiftData = dataList.sort((a, b) =>
          a.value.localeCompare(b.value)
        )
      })
    },
    async getProcessData() {
      if (!this.pendingGoodsCode) return
      request({
        url: `/factory/mrp/pending/goods/package/work/log/dict/process_tech/${this.pendingGoodsCode}`,
        method: 'GET',
        data: {},
      }).then((res) => {
        this.pdProcessDictStepOptions = this.conversionProperties(
          res.body.data || []
        )
      })
    },
    conversionProperties(dataList) {
      return dataList.map((m) => {
        const {
          f0: pdProcessDictStep,
          f1: pdTechDictCode,
          f2: techChargeUnit,
        } = this.parseToFields(m?.extensions, '*|-|*')
        const { f0, f1: techName, f2: techChargeUnitText } = this.parseToFields(
          m?.label,
          ' - '
        )
        return {
          ...m,
          v_value: pdProcessDictStep,
          v_label: f0,
          techName,
          pdProcessDictStep,
          pdTechDictCode,
          techChargeUnit,
          techChargeUnitText,
        }
      })
    },
    close() {
      this.$emit('update:visible', false)
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      const listUserCode = this.formData.userList.map((item) => item.userCode)
      if (!listUserCode?.length) {
        this.$message.warning(
          this.$l('form_label_message_choose_user') || '请选择报工人员'
        )
        return
      }
      if (this.loadingOpen()) return
      const res = await this.$api
        .pendingGoodsPackageWorkLogSaveApi({
          ...this.formData,
          listUserCode,
          pcEdit: true,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      if (!this.disabled) this.$emit('reload')
    },

    calConsumerTime() {
      const { totalActualTimeSeconds } = this.formData
      if (!totalActualTimeSeconds) return
      this.formData.consumerHour =
        Math.floor(totalActualTimeSeconds / 3600) || ''
      this.formData.consumerMinute =
        Math.floor((totalActualTimeSeconds % 3600) / 60) || ''
    },
    handleClose(done) {
      if (this.disabled) {
        this.close()
        return
      }
      this.$confirm(
        this.$l('INDEX.tips_check_saved') ||
          '如对当前页面内容做过修改，请先保存后再关闭。',
        this.$l('INDEX.tips_close_page') || '确认关闭当前页面吗',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText:
            this.$l('INDEX.product_dialog_btn_cancel') || '取消',
          type: 'warning',
        }
      )
        .then(() => {
          done()
        })
        .catch(() => {})
    },
    reasonChange(val, _label, params) {
      this.formData.breakReasonCode = params.valueString
      this.formData.breakReasonName = params.labelString
    },
    chooseUserConfirm(items) {
      if (!items?.length) return
      const techChargeUnit = this.formData?.techChargeUnit
      const techChargeUnitText = this.formData?.techChargeUnitText
      const userCodes = this.formData.userList.map((item) => item.userCode)
      const list = items
        .filter((item) => !userCodes.includes(item.userCode))
        .map((item) => {
          return {
            userCode: item.userCode,
            userNo: item.userNo,
            userName: item.userName,
            reportedWorkQty: 0,
            techChargeUnit,
            techChargeUnitText,
          }
        })
      this.formData.userList.push(...list)
      this.splitWorklogUser()
    },
    del(index) {
      this.formData.userList.splice(index, 1)
      this.splitWorklogUser()
    },
    splitWorklogUser() {
      const { userList } = this.formData
      if (!userList?.length) return

      const reportedWorkQty = this.formData?.reportedWorkQty || 0
      const techChargeUnit = this.formData?.techChargeUnit
      const techChargeUnitText = this.formData?.techChargeUnitText

      const reportedWorkQtyItem = divideRound(
        reportedWorkQty,
        userList.length,
        3
      )

      let calcReportedWorkQty = 0
      for (const i in userList) {
        const worklogUserItem = userList[i]
        worklogUserItem.techChargeUnit = techChargeUnit
        worklogUserItem.techChargeUnitText = techChargeUnitText
        if (i == userList.length - 1) {
          worklogUserItem.reportedWorkQty = subtract(
            reportedWorkQty,
            calcReportedWorkQty
          )
          break
        }
        worklogUserItem.reportedWorkQty = reportedWorkQtyItem
        calcReportedWorkQty = add(calcReportedWorkQty, reportedWorkQtyItem)
      }
      this.formData.userList = [...userList]
    },
    workShiftChange(e) {
      this.mrpWorkShiftData.forEach((item) => {
        if (item.value == e) {
          this.formData.workShiftName = item.label
        }
      })
    },
    updateTimeSeconds() {
      this.formData.totalActualTimeSeconds = add(
        (this.formData.consumerHour || 0) * 3600,
        (this.formData.consumerMinute || 0) * 60
      )
    },
    techChange(e) {
      const findData = this.pdProcessDictStepOptions.find(
        (item) => item.value == e
      )
      if (!findData) return
      const {
        techName,
        pdProcessDictStep,
        pdTechDictCode,
        techChargeUnit,
        techChargeUnitText,
        v_label,
      } = findData

      this.formData.techName = techName
      this.formData.pdProcessDictStep = pdProcessDictStep
      this.formData.pdTechDictCode = pdTechDictCode
      this.formData.techChargeUnit = techChargeUnit
      this.formData.techChargeUnitText = techChargeUnitText
      this.formData.processName = v_label
      this.splitWorklogUser()
    },
    parseToFields(label, splitText) {
      const parts = label.split(splitText).map((v) => {
        v = v.trim()
        return v === '' || v.toLowerCase() === 'null' ? null : v
      })
      const [f0, f1, f2] = [
        parts[0] || null,
        parts[1] || null,
        parts[2] || null,
      ]

      return { f0, f1, f2 }
    },
    async changeGoods() {
      await this.getData()
      this.$refs.goodsInfoRef.getData(this.formData.pendingGoodsCode)
      this.$emit('reload')
    },
  },
}
</script>
<style lang="scss" scoped>
::v-deep .el-drawer__body {
  padding: 0 20px 12px;
}
::v-deep .el-drawer__header {
  align-items: center;
  color: #141516;
  display: flex;
  margin-bottom: 12px;
  padding: 10px 20px 0;
}
</style>
